var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAddWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User / User_Add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 15.832C12.5 13.9911 10.2614 12.4987 7.5 12.4987C4.73858 12.4987 2.5 13.9911 2.5 15.832M15.8333 13.332V10.832M15.8333 10.832V8.33203M15.8333 10.832H13.3333M15.8333 10.832H18.3333M7.5 9.9987C5.65905 9.9987 4.16667 8.50631 4.16667 6.66536C4.16667 4.82442 5.65905 3.33203 7.5 3.33203C9.34095 3.33203 10.8333 4.82442 10.8333 6.66536C10.8333 8.50631 9.34095 9.9987 7.5 9.9987Z",
    stroke: "#0077FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddWishlist);
export default __webpack_public_path__ + "static/media/User_Add_Wishlist.69deba4417230512f70ad12c36f4e231.svg";
export { ForwardRef as ReactComponent };